import { AUA_DETAILS_PAGE_PATH } from 'modules/anonymousUserTracking/constants';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'ui/tooltip/Tooltip';
import {
  CriteriaMetadata,
  CriteriaName,
  DetailsCellDescription,
  DetailsCellId,
  DetailsCellWrapper,
  WithBulletPoint,
} from '../AnonymousUserTracking.styled';

export const DetailsCell = ({ criteria }: { criteria: AnonUserCriteria }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isDescriptionClamped, setIsDescriptionClamped] = useState(false);
  const { name, description } = criteria.fields;

  const checkClamping = () => {
    const el = ref.current;
    if (!el) return;

    const elStyle = window.getComputedStyle(el);
    const lineClamp = parseInt(elStyle.getPropertyValue('-webkit-line-clamp'), 10);

    setIsDescriptionClamped(
      lineClamp > 0 &&
        elStyle.getPropertyValue('overflow') === 'hidden' &&
        el.scrollHeight > el.clientHeight,
    );
  };

  useEffect(() => {
    checkClamping();
    window.addEventListener('resize', checkClamping);
    return () => window.removeEventListener('resize', checkClamping);
  }, [description]);

  return (
    <DetailsCellWrapper>
      <CriteriaName href={AUA_DETAILS_PAGE_PATH(criteria.id)} useReactRouter>
        {name}
      </CriteriaName>
      <CriteriaMetadata>
        <DetailsCellId>{`ID ${criteria.id}`}</DetailsCellId>
        {description && (
          <WithBulletPoint>
            <Tooltip isEnabled={isDescriptionClamped} tooltipContent={description}>
              <DetailsCellDescription ref={ref} $isClamped={isDescriptionClamped}>
                {description}
              </DetailsCellDescription>
            </Tooltip>
          </WithBulletPoint>
        )}
      </CriteriaMetadata>
    </DetailsCellWrapper>
  );
};
